import { ContentChildren, Directive, ElementRef, Input, QueryList } from "@angular/core";
import { BehaviorSubject, filter, Subject, takeUntil } from "rxjs";
import { GridItemDirective } from "./grid-item.directive";
import { GridLayoutService } from "./grid-layout.service";

@Directive({
    selector: '[gridContainer]',
    providers: [GridLayoutService]
})
export class GridContainerDirective {
    readonly #destroy = new Subject<void>()

    @ContentChildren(GridItemDirective)
    gridItemsQL: QueryList<GridItemDirective>

    readonly colCountSubject = this._gridLayoutService.colCountSubject;
    @Input() get colCount() {
        return this.colCountSubject.value
    }
    set colCount(value: number) {
        this.colCountSubject.next(value);
    }

    readonly spacingSubject = new BehaviorSubject<number>(10)
    @Input() get spacing() {
        return this.spacingSubject.value
    }
    set spacing(value) {
        this.spacingSubject.next(value)
    }

    get #element() {
        return this._elementRef.nativeElement
    }


    constructor(
        private readonly _gridLayoutService: GridLayoutService,
        private readonly _elementRef: ElementRef<HTMLElement>
        // private readonly _screenUtilsService: ScreenUtilsService
    ) {

    }




    ngAfterViewInit() {


        this.colCountSubject.pipe(
            filter(Boolean),
            takeUntil(this.#destroy)
        )
            .subscribe((colCount) => {
                this.#element.classList.forEach(className => {
                    if (className.startsWith('grid-columns')) {
                        this.#element.classList.remove(className)
                    }
                })

                this.#element.classList.add('grid-columns-' + colCount);
            })


        this.spacingSubject.pipe(
            filter(Boolean),
            takeUntil(this.#destroy)
        )
            .subscribe((spacing) => {
                this.#element.style.columnGap = spacing + 'px';
            })

    }



    ngOnDestroy() {
        this.#destroy.next()
        this.#destroy.complete()
    }
}